import {assert} from 'assert-ts';
import type {Schemas} from 'api/dto.generated';
import {mapImprintDto} from 'api/mappers/mapImprintDto';
import {mapPhysicalPropertiesDto} from 'api/mappers/mapPhysicalPropertiesDto';
import {mapAgentRoleDto} from 'services/agent/mappers/mapAgentRoleDto';
import {CodeListRef} from 'schemas/references';
import type {FullManifestation} from '../types';
import {mapToRuntime} from './mapRuntime';
import {mapTitleInfoDto} from './mapTitleInfoDto';
import {mapWorkPrizesWonDto} from './mapWorkBaseDto';
import {mapWorkRelationsDto} from './mapWorkRelationsDto';

export const mapManifestationWithExpressionDto = (
  dto: Schemas.ManifestationWithExpressionDto,
): FullManifestation => {
  const {
    expression,

    agents: manifestationAgents,
    imprints,
    physicalProperties,
    marketingData,
    ddsData,
    runtimeSeconds,
    ...manifestationDto
  } = dto;
  const {
    work,

    agents: _expressionAgents,
    ...expressionDto
  } = assert(expression);
  const {
    agents: _workAgents,
    workRelations,
    agentRelations,
    seriesRelations,
    prizes,
    ...workDto
  } = assert(work);

  const physicalPropertyFields = mapPhysicalPropertiesDto(physicalProperties);
  const links = mapWorkRelationsDto({
    workRelations,
    agentRelations,
    seriesRelations,
  });

  // const manifestationLinks = mapManifestationRelationsDto({seriesRelations: manifestationSeriesRelations});

  return {
    ...workDto,
    type: workDto.type ?? CodeListRef.WORK_TYPE.Bok,
    ...expressionDto,
    ...manifestationDto,
    id: assert(manifestationDto.id, 'mapManifestationDto: id expected', dto),
    workId: assert(workDto.id, 'mapManifestationDto: workId expected', dto),
    expressionId: assert(
      expressionDto.id,
      'mapManifestationDto: expressionId expected',
      dto,
    ),
    created: assert(
      manifestationDto.created,
      'mapManifestationDto: created expected',
      dto,
    ),
    modified: assert(
      manifestationDto.modified,
      'mapManifestationDto: modified expected',
      dto,
    ),
    status: assert(
      manifestationDto.status,
      'mapManifestationDto: status expected',
      dto,
    ),
    productFormDetail: manifestationDto.productFormDetail,
    ...mapTitleInfoDto(manifestationDto.titleInfo),
    agents: manifestationAgents?.map(mapAgentRoleDto),
    workAgents: _workAgents?.map(mapAgentRoleDto),
    links,
    prizes: mapWorkPrizesWonDto(prizes),
    expressionAgents: _expressionAgents?.map(mapAgentRoleDto),
    imprints: imprints ? imprints.map(mapImprintDto) : undefined,
    products: marketingData ? marketingData.products : undefined,
    ddsStatus: ddsData?.ebooks,
    runtimeSeconds: mapToRuntime(runtimeSeconds),
    ...physicalPropertyFields,
  };
};
